import api from '../api'

export enum ResetType {
    SOFT = 'Soft',
    HARD = 'Hard',
}

export function resetOcppChargePoint(
    chargePointId: string,
    options: { type: ResetType }
): Promise<Record<string, unknown>> {
    return api.put({ path: `/ocppcommands/${chargePointId}/reset`, body: options })
}
